module.exports = __webpack_public_path__ + "static/media/insulation_lcs_60yd_n.e1a00851.csv";